export default "__VITE_ASSET__7cda82d6__"